
const FeedbackSection = () => {
  // FeedbackSection 컴포넌트를 빈 컴포넌트로 변경하여 Proven 섹션을 완전히 제거
  return null;
};

export default FeedbackSection;
